import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  userInfoLocal: null, // default null, load from store preloadedState
};

export const isOpenSlice = createSlice({
  name: 'isOpen',
  initialState,
  reducers: {
    isLoginAction: (state, action) => {
      state.isOpen = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfoLocal = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem("userInfo", JSON.stringify(action.payload)); // persist in browser only
      }
    },
    logout: (state) => {
      state.userInfoLocal = null;
      if (typeof window !== 'undefined') {
        localStorage.removeItem("userInfo"); // clear localStorage only in browser
      }
    },
  },
});

export const { isLoginAction, setUserInfo, logout } = isOpenSlice.actions;
export const isOpenReducer = isOpenSlice.reducer;
